// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Image-module-coreImage-cnt9q{display:flex;align-items:center;justify-content:center;margin-top:10px}.Image-module-coreImage-cnt9q img{border-radius:20px;width:100%}.Image-module-fullWidth-2FrPJ div{width:100%}", ""]);
// Exports
exports.locals = {
	"coreImage": "Image-module-coreImage-cnt9q",
	"fullWidth": "Image-module-fullWidth-2FrPJ"
};
module.exports = exports;
